import React, { useEffect, useState } from "react";

const Checkbox = (props: { label: any, value: string, onChange: Function, isActive?: boolean, className?: string }) => {
  const [hover, setHover] = useState(false);
  const [active, setActive] = useState(props.isActive != undefined ? props.isActive : false);

  useEffect(() => {
    if(active !== props.isActive) {
      setActive(props.isActive);
    }
  }, [ active, props.isActive ])

  return (
    <div
      className={`transition-all flex items-center pb-2 text-sm text-black cursor-pointer hover:text-red ${props.className}`}
      onClick={(_) => {
        setActive(!active);
        props.onChange({
          status: !active,
          value: props.value
        });
      }}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      onKeyDown={(e) => {
        if(e.key === 'Enter') {
          setActive(!active);
          props.onChange({
            status: !active,
            value: props.value
          });
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className={`transition-all h-5 w-5 bg-white border rounded flex justify-center items-center ${ hover ? "border-red shadow-lg" : "" } cursor-pointer`}>
        {
          active &&
          <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
        }
      </div>
      <label className="pl-2 pt-1 leading-0 cursor-pointer">
        { props.label }
      </label>
    </div>
  )
}

export default Checkbox;
